(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/navigation-menu/assets/javascripts/navigation.js') >= 0) return;  svs.modules.push('/components/components/navigation-menu/assets/javascripts/navigation.js'); 

'use strict';

svs.components = svs.components || {};
svs.components.data = svs.components.data || {};
svs.components.data.navigation = svs.components.data.navigation || {};

var activateItem = function($item, enabled) {
  $item
    .attr('data-active', enabled)
    .attr('data-selected', enabled)
    .attr('data-routed', enabled);
};

var findItemById = function(id, item) {
  if (item.items) {
    var tempItem;
    for (var i = 0, len = item.items.length; i < len; i++) {
      tempItem = findItemById(id, item.items[i]) || {};
      if (id && tempItem.id === id) {
        item.id && (tempItem.parentId = item.id);
        break;
      }
      tempItem = {};
    }
    item = tempItem;
  }
  return item;
};

svs.components.Navigation = function(element) {
  var $el,
    dimmer,
    model = { isOpen: false },
    $body = $(document.body),
    $hamburger = $('.js-nav-hamburger'),
    hamburgerCallback,
    hamburgerIcon = 'menu',
    lastSort,
    menu = {},
    self = this;

  this.init = function(element) {
    $el = element;
    self.render(true);
    self.setupListeners();
    self.openMenuOnHash();
    self.checkUserStatus();
    return true;
  };

  this.setHamburgerCallback = function(cb) {
    hamburgerCallback = cb;
  };

  this.restoreHamburgerCallback = function() {
    hamburgerCallback = undefined;
  };

  this.setHamburgerIcon = function(icon) {
    hamburgerIcon = icon;
    $hamburger.html(
      svs.components.navigation_menu.templates.hamburger_icon({ icon: icon })
    );
  };

  this.setupSwiper = function() {
    if (!this.swiperActive) {
      if (
        svs.core.detect.breakpoint.lessThan('lg') ||
        svs.core.detect.breakpoint.greaterThan('md') &&
        !$body.hasClass('nav-top')
      ) {
        svs.components.swiper.init($el, {
          scrollbars: false,
          scrollingX: false,
          updateOnWindowResize: true,
          updateOnChanges: true
        });
        this.swiperActive = true;
      }
    }
  };

  this.removeSwiper = function() {
    if (this.swiperActive) {
      $el.find('.nav-list:first').unwrap(); 
      this.swiperActive = false;
    }
  };

  this.findItemTitle = function($item) {
    return $(
      $item
        .find('.nav-list-item-link-title')
        .contents()
        .get(0)
    )
      .text()
      .trim();
  };

  this.createGAEvent = function(e, callback) {
    var $item = $(e.currentTarget);
    if (!e.isTrigger) {
      var gaEvent = {
          category: 'Menu'
        },
        itemTitle = this.findItemTitle($item),
        parentTitle = this.findItemTitle($item.parents('.nav-list-item'));

      if (parentTitle) {
        if ($item.parents('.nav-submenu-user').length) {
          gaEvent.action = 'User';
        } else {
          gaEvent.action = parentTitle;
        }
        gaEvent.opt_label = itemTitle;
      } else {
        gaEvent.action = itemTitle;
      }
      svs.components.analytics.trackEvent(gaEvent, function() {
        if (callback) {
          callback();
        } else {
          location.href = $item.attr('href');
        }
      });
    }
    e.preventDefault();
    return false;
  };

  this.setupListeners = function() {
    var self = this;

    svs.core.detect.breakpoint.on('change', function() {
      if (
        svs.core.detect.breakpoint.greaterThan('md') &&
        $body.hasClass('nav-top')
      ) {
        self.sort('top');
      }
      if (
        svs.core.detect.breakpoint.lessThan('lg') ||
        !$body.hasClass('nav-top')
      ) {
        self.sort('side');
      }
    });

    svs.core.detect.breakpoint.trigger('change');

    if (!svs.core.detect.formfactor.desktop() || !$body.hasClass('nav-top')) {
      self.setupSwiper();
      svs.core.detect.breakpoint.on('change', function() {
        if (
          svs.core.detect.breakpoint.greaterThan('md') &&
          $body.hasClass('nav-top')
        ) {
          self.removeSwiper();
        } else {
          self.setupSwiper();
        }
      });
    }

    if (svs.components.data.navigation.debug) {
      $('.js-nav-debug-toggle-top').on('change', function() {
        if ($body.hasClass('nav-top')) {
          $body.removeClass('nav-top');
        } else {
          $body.addClass('nav-top');
        }
      });
      setInterval(function() {
        var classes = $body.attr('class').replace('wrap', '');
        $('.js-nav-debug-classnames').text(classes);
      }, 500);
    }

    $hamburger.click(function() {
      if (hamburgerCallback) {
        hamburgerCallback();
      } else {
        self.toggle(true);
      }
    });

    dimmer.click(function() {
      self.closeSubmenu();
      self.closeMenu();
    });

    $el.on('click', '.nav-list-item-link', function(e) {
      var $item = $(this).parent(),
        isChildMenuItem = Boolean($(this).parents('.nav-submenu').length),
        hasSubmenu = $item.find('.nav-submenu').length,
        wasSelected = $item.attr('data-selected'),
        wasActive = $item.attr('data-active'),
        hasAction = $item.attr('data-action'),
        selectedState = true,
        activeState = true,
        subMenuState = true,
        closeMenu = false;

      if (hasAction) {
        self.createGAEvent(e, function() {
          self.callToAction(hasAction);
        });
        return false;
      }

      if (isChildMenuItem) {
        if (!wasSelected) {
          $('.nav-submenu .nav-list-item[data-selected]')
            .attr('data-active', null)
            .attr('data-selected', null);
        }
      } else {
        $el
          .find('ul')
          .first()
          .children()
          .attr('data-active', null)
          .attr('data-selected', null);
        if (hasSubmenu) {
          if (wasSelected) {
            if (wasActive) {
              if (svs.core.detect.breakpoint.current === 'lg') {
                closeMenu = true;
              }
              selectedState = null;
              activeState = null;
              subMenuState = false;
            }
          }
        } else {
          activeState = null;
          subMenuState = false;
          if (wasSelected) {
            selectedState = null;
          }
        }
      }

      $item
        .attr('data-active', activeState)
        .attr('data-selected', selectedState);

      if (subMenuState) {
        self.openSubmenu();
      } else if (!isChildMenuItem) {
        if (closeMenu) {
          self.closeMenu();
        } else {
          self.closeSubmenu();
        }
      }

      if (hasSubmenu) {
        return false;
      }

      self.createGAEvent(e);
    });

    if (svs.utils.keylistener) {
      this.keyListenerId = svs.utils.keylistener.addKeyboardListener(function(
        event
      ) {
        self.handleKeys(event);
      });
    }

    this.handleKeys = function(event) {
      if (event.keyCode === svs.utils.keylistener.KEY_ESC) {
        self.closeMenu();
      }
    };
  };

  this.sort = function(position) {
    if (lastSort !== position) {
      var $firstLevel = $el.find('.nav-list[data-level=0]'),
        $firstLevelItems = $firstLevel.children('.nav-list-item'),
        dataKey = 'order-side';

      if (position === 'top') {
        dataKey = 'order-top';
      }

      $firstLevelItems
        .sort(function(a, b) {
          var compA = $(a).data(dataKey),
            compB = $(b).data(dataKey);
          return compA < compB ? -1 : compA > compB ? 1 : 0;
        })
        .each(function(i, item) {
          $firstLevel.append(item);
        });

      lastSort = position;
    }
  };

  this.render = function(init) {
    model.url =
      window.location.pathname !== '/' ? window.location.pathname : '/';
    dimmer = $('.js-nav-dimmer');
    if (!init) {
      $el.html(
        svs.components.navigation_menu.templates.navigation_menu({
          'navigation-menu': svs.components.data.Navigation,
          icon: hamburgerIcon
        })
      );
    }
  };

  this.callToAction = function(action) {
    switch (action) {
      case 'openChat':
        svs.components.chat.open();
        break;
      default:
    }
    self.closeMenu();
  };

  this.checkUserStatus = function() {
    var loggedInName;
    if (
      svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL) ||
      svs.core.userSession.hasRole(svs.core.userSession.roles.RETAILER)
    ) {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL)) {
        loggedInName =
          svs.components.Storage.browser.get(
            'internalAlias',
            'svs.components.login'
          ) || 'Admin';
      } else {
        loggedInName =
          svs.components.Storage.browser.get('alias', 'retailerLogin') ||
          'Ombud';
      }
      $('.js-nav-list-item-link-user > .nav-list-item-link-title').text(
        loggedInName
      );
    }
  };

  this.openMenuOnHash = function() {
    if (location.hash) {
      for (
        var i = 0, length = svs.components.data.navigation.items.length;
        i < length;
        i++
      ) {
        var item = svs.components.data.navigation.items[i];
        if (item.openOnHash) {
          if (
            location.hash ===
            '#' + item.url.replace(/^[/]'/, '')
          ) {
            $(
              '.js-nav-list-item-' + item.id + ' > .nav-list-item-link'
            ).trigger('click');
          }
        }
      }
    }
  };

  this.openMenuById = function(id) {
    self.openMenu();
    for (
      var i = 0, length = svs.components.data.navigation.items.length;
      i < length;
      i++
    ) {
      var item = svs.components.data.navigation.items[i];
      if (item.id === id) {
        $('.js-nav-list-item-' + item.id + ' > .nav-list-item-link').trigger(
          'click'
        );
        return true;
      }
    }
  };

  this.setActiveById = function(id) {
    var item = findItemById(id, svs.components.data.navigation);
    if (item.id) {
      var $item = $(
          '.js-nav-list-item-' + item.id + ' > .nav-list-item-link'
        ).parent(),
        $parent = $('.js-nav-list-item-' + item.parentId);
      activateItem($('.nav-submenu .nav-list-item[data-selected]'), null);
      activateItem($item, true);
      activateItem($parent, true);
    }
    return item;
  };

  this.preventDefault = function(e) {
    var target = $(e.target);
    if (target.parents('.js-navigation-menu').length === 0) {
      e.preventDefault();
    }
  };

  this.openMenu = function() {
    if (!model.isOpen) {
      model.isOpen = true;
      $hamburger.get()[0].setAttribute('aria-label', 'Öppna huvudmenyn');
      $body.addClass('nav-animate-open nav-open');

      $body.one(
        'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
        function() {
          $body.removeClass('nav-animate-open');
        }
      );
    }
  };

  this.closeMenu = function(menuItem) {
    if (menuItem) {
      $(menuItem)
        .attr('data-active', null)
        .attr('data-selected', null);
    } else {
      if (model.isOpen) {
        model.isOpen = false;
        $el
          .find('ul')
          .first()
          .children()
          .attr('data-active', null)
          .attr('data-selected', null);
        $hamburger.get()[0].setAttribute('aria-label', 'Stäng huvudmenyn');
        $body.addClass('nav-animate-close').removeClass('nav-open');
        $body.one(
          'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
          function() {
            $body.removeClass('nav-animate-close');
          }
        );
      }
    }
    $body.removeClass('nav-submenu-open');
  };

  this.openSubmenu = function() {
    if (!model.isOpen) {
      this.openMenu();
    }
    $body.addClass('nav-submenu-open');
  };

  this.closeSubmenu = function() {
    $('.nav > .nav-list > .nav-list-item[data-active]').attr(
      'data-active',
      null
    );
    $body.removeClass('nav-submenu-open');
  };

  this.toggle = function(isMobile) {
    if (!model.isOpen) {
      self.openMenu();
    } else {
      self.closeMenu();
      if (isMobile) {
      }
    }
  };

  this.showDimmer = function() {
    return false;
  };

  this.hideDimmer = function() {
    return false;
  };

  this.getUserNotifications = function() {
    return false;
  };

  this.hideHamburger = function() {
    if ($hamburger.is(':visible')) {
      $hamburger.hide();
    }
  };

  this.showHamburger = function() {
    if ($hamburger.is(':hidden')) {
      $hamburger.show();
    }
  };

  this.toggleHamburger = function() {
    if ($hamburger.is(':hidden')) {
      this.showHamburger();
    } else {
      this.hideHamburger();
    }
  };

  menu = new svs.core.Events({
    toggle: this.toggle,
    open: this.openMenu,
    close: this.closeMenu,
    openMenuById: this.openMenuById,
    setActiveById: this.setActiveById,
    showDimmer: this.showDimmer,
    hideDimmer: this.hideDimmer,
    hideHamburger: this.hideHamburger,
    showHamburger: this.showHamburger,
    toggleHamburger: this.toggleHamburger,
    setHamburgerIcon: this.setHamburgerIcon,
    setHamburgerCallback: this.setHamburgerCallback,
    restoreHamburgerCallback: this.restoreHamburgerCallback,
    render: this.render,
    getUserNotifications: this.getUserNotifications
  });

  self.init(element);

  return menu;
};

svs.components.navigation = new svs.components.Navigation($('.js-nav'));

 })(window);